import React from 'react'

export const Done: React.FC<{ style?: any }> = ({ style }) => (
  <svg {...style} width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 5L4 8L11 1" stroke="currentColor" strokeWidth="1.8" />
  </svg>
)
